import { takeLatest, call, put } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  getMetadataRequested,
  getMetadataSucceeded,
  getMetadataFailed,
  createMetadataRequested,
  createMetadataSucceeded,
  createMetadataFailed,
} from '../reducers/metadata.slice';
import MetadataAPIService from '../../services/metadata.service';

function* fetchMetadata(): Generator<any, void, any> {
  try {
    const service = new MetadataAPIService();
    const metadata = yield call([service, service.getMetadata]);

    yield put({ type: getMetadataSucceeded.type, payload: metadata });
  } catch (error: any) {
    console.log('saga::fetchMedias::', error.message);

    yield put<{ type: string; payload: SagaError }>({
      type: getMetadataFailed.type,
      payload: { message: error.message },
    });
  }
}

function* createMetadata(action: PayloadAction<Media>): Generator<any, void, any> {
  try {
    const service = new MetadataAPIService();
    const metadata = yield call([service, service.createMetadata], action.payload);

    yield put({ type: createMetadataSucceeded.type, payload: metadata });
  } catch (error: any) {
    console.log('saga::fetchMedias::', error.message);

    yield put<{ type: string; payload: SagaError }>({
      type: createMetadataFailed.type,
      payload: { message: error.message },
    });
  }
}

export default function* watchAsync() {
  yield takeLatest(getMetadataRequested.type, fetchMetadata);
  yield takeLatest(createMetadataRequested.type, createMetadata);
}
